{
  "age": "Edad",
  "complianceState": "Estado de cumplimiento",
  "dateOfBirth": "Fecha de nacimiento",
  "marketValue": "Valor de mercado",
  "createdAt": "Creado en",
  "state": "Estado",
  "accountType": "Tipo de cuenta",
  "goalType": "Tipo de meta",
  "jurisdiction": "Jurisdicción",
  "user": "Clientes",
  "account": "Cuentas",
  "language": "Idioma",
  "isOfficerOfPublicCompany": "Es funcionario de una empresa pública",
  "isOwnerOfPublicCompany": "Es propietario de una empresa pública",
  "isMemberOfIiroc": "Es miembro de IIROC",
  "politicallyExposedForeignPerson": "Es persona extranjera políticamente expuesta",
  "politicallyExposedDomesticPerson": "Es persona nacional políticamente expuesta",
  "closeAssociateOfPEP": "Es asociado cercano de PEP",
  "isAccreditedInvestor": "Es inversor acreditado",
  "powerOfAttorneyGranted": "Poder notarial otorgado",
  "headOfInternationalOrganization": "Jefe de Organización Internacional",
  "isVulnerablePerson": "Es una persona vulnerable",
  "isOwnerOfEntity": "Es propietario de la entidad",
  "amount": "Importe",
  "source": "Fuente",
  "type": "Tipo",
  "withdrawalReason": "Motivo de la retirada",
  "applyForGovFunds": "Solicitar fondos gubernamentales",
  "countryOfTaxResidence": "País de residencia fiscal",
  "paysForeignTaxes": "Paga impuestos extranjeros",
  "accountJurisdiction": "Jurisdicción de la Cuenta",
  "advisorInterest": "Interés del Asesor",
  "investmentFirmTrade": "Operación de la Firma de Inversión",
  "useBorrowedMoney": "Uso de Dinero Prestado",
  "isReportingIssuer": "Es Emisor Informante",
  "tradingAuthorityOverAccountGranted": "Autoridad de Negociación sobre la Cuenta Concedida"
}
